import React, { useState } from "react";
import DateDisplay from "../common/DateDisplay";
import {
  DropDownIcon,
  MediaIcon,
  MembersIcon,
  TeamSettingIcon,
} from "../common/Icon";
import { TodayTeamGoalsCards, teamDropdownData } from "../common/Helper";
import SetTodayProductivity from "./SetTodayProductivity";

const TeamGoals = () => {
  // DROPDOWN
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState();

  const handleOptionClick = (data) => {
    setSelectedOption(data.teamName);
    setDropdownOpen(false);
  };
  return (
    <>
      <div className="flex flex-col xm:flex-row items-center justify-between mx-[11px] relative">
        <DateDisplay />
        <div className="flex justify-between items-center pt-2 xm:pt-0">
          <div
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex cursor-pointer items-center justify-between border border-primary rounded-[37px] py-[12px] px-2 sm:px-4 md:px-[14px]  overflow-hidden relative w-[200px] 3xl:w-[220px]">
            <MembersIcon />
            <p className="px-3 xm:px-1 sm:px-2 text-[10px] xs:text-xs 3xl:text-sm font-normal text-primary">
              Team : {selectedOption || "Trading-Secrets"}
            </p>
            <span
              className={`duration-200  ${dropdownOpen ? "rotate-180" : ""}`}>
              <span className=" block">
                <DropDownIcon />
              </span>
            </span>
          </div>
          {dropdownOpen && (
            <ul className="cursor-pointer  overflow-hidden absolute z-50 top-[100%] sm:top-[91%] 3xl:top-[100%] right-0 w-[200px] p-0 m-0  list-none bg-[#F7F6FF] shadow-[0px_5.86667px_17.6px_0px_rgba(0,_0,_0,_0.10)] rounded-md">
              <div className="overflow-y-auto h-[200px] overflow_x_scroll_style">
                {teamDropdownData.map((data, index) => (
                  <li
                    className="text-black text-xs 3xl:text-sm font-medium  hover:bg-[#EAEAFE] hover:text-black px-4 py-3 duration-200 mr-1"
                    key={index}
                    onClick={() => handleOptionClick(data)}>
                    {data.teamName}
                  </li>
                ))}
              </div>
            </ul>
          )}
          <div className="flex justify-between ">
            <div className="ml-3 xm:ml-3 3xl:ml-5 cursor-pointer w-[38px] h-[38px] bg-[#F2F2FE] hover:bg-primary rounded-full p-2 mediaIcon-btn duration-300">
              <MediaIcon />
            </div>
            <div className="ml-3 3xl:ml-5 cursor-pointer teamSettingIcon-btn duration-300">
              <TeamSettingIcon />
            </div>
          </div>
        </div>
      </div>
      <div className="pt-5 mx-[11px]">
        <div className="flex flex-wrap justify-center md:justify-between productivity_scrollbar_line">
          {TodayTeamGoalsCards.map((obj, index) => (
            <div
              key={index}
              className="w-full xm:max-w-[45%] md:max-w-[22%] lg:max-w-[24%] xl:max-w-[23%] py-[14px] px-3 rounded-lg shadow-workflow_item_card_shadow bg-white mt-2 lg:my-0 mx-2.5 lg:mx-0">
              <div className="">
                <div>
                  <img
                    className="w-[33px] h-[33px]"
                    src={obj.similarIcon}
                    alt="contact-icon"
                  />
                </div>
                <p className="pt-3 lg:pt-4  font-semibold text-xs 3xl:text-sm text-black">
                  {obj.para}
                </p>
                <h5 className="font-bold text-base md:text-xl lg:text-2xl text-black pt-1">
                  {obj.contactpercent}
                </h5>
                <div className=" w-full h-[9px] bg-[rgba(146,_146,_146,_0.2)] rounded-[37px] mt-3.5 ">
                  <div
                    className={`${obj.className} h-full rounded-[37px]`}></div>
                </div>
                <div className="pt-1.5 flex items-center justify-between">
                  <p className="font-medium text-[9px] 3xl:text-xs text-black ">
                    {obj.para2}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        onClick={() => setDropdownOpen(false)}
        className={`fixed inset-0 min-h-full w-full z-20  bg-black opacity-10 ${
          dropdownOpen ? "w-[100%] " : "hidden"
        }`}></div>
      <SetTodayProductivity />
    </>
  );
};

export default TeamGoals;
